module.exports = __webpack_public_path__ + "static/img/01.3edf3bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/01.png
// module id = Bzbw
// module chunks = 1